import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import App from './App';

import { SoftUIControllerProvider } from './context';

import { Provider } from 'react-redux';
import { store } from './features/store';

import reportWebVitals from './reportWebVitals'; // for just performance checking
import { AuthProvider } from './context/AuthProvider';


const root = ReactDOM.createRoot(
  document.getElementById('admin-root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter basename="/admin">
      <Provider store={store}>
        <SoftUIControllerProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </SoftUIControllerProvider>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(// // console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
